import * as React from 'react'
import { useLocation } from 'react-router-dom'

const RouteChangeListener = () => {
  let location = useLocation();

  React.useEffect(() => {
    // Do something with this on every route change
    window.location.href
  }, [location]);

  return null
}

export default RouteChangeListener